<template>
  <div class="app-wrapper jukie">
    <mj-header />
    <mj-container
      class="mt-8 sm:-mt-40"
      :class=" { 'flex': !isInitalized}"
    >
      <mj-spinner
        v-if="!isInitalized"
        :size="200"
      />
      <router-view v-else />
    </mj-container>

    <portal-target
      name="modals"
      multiple
    />
    <mj-modal-window />
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import Header from '@/components/ui/header/Header.vue';

export default {
  name: 'Jukie',

  components: {
    'mj-header': Header,
  },

  computed: {
    ...mapGetters(['isInitalized']),
  },

};

</script>
